import { agent } from '@shared/services/agent';
import {
  CreateLockerRequest,
  Locker,
  LockerOfficeSummary,
  UpdateLockerRequest,
  WaitingList
} from './lockers.models';

export function getLockerSummary(): Promise<LockerOfficeSummary[]> {
  return agent.requests.get('/api/company/lockers/summary');
}

export function getLockersForOffice(rootOfficeId: number): Promise<Locker[]> {
  return agent.requests.get(`/api/company/lockers/office/${rootOfficeId}`);
}

export function createLockerRequest(request: CreateLockerRequest): Promise<Locker> {
  return agent.requests.post('/api/company/lockers', request);
}

export function updateLockerRequest(lockerId: number, request: UpdateLockerRequest): Promise<Locker> {
  return agent.requests.put(`/api/company/lockers/${lockerId}`, request);
}

export function deleteLockerRequest(lockerId: number): Promise<any> {
  return agent.requests.del(`/api/company/lockers/${lockerId}`, true);
}

export function assignLockerRequest(lockerId: number, userId: string): Promise<Locker> {
  return agent.requests.put(`/api/company/lockers/${lockerId}/assignment`, { userId });
}

export function unassignLockerRequest(lockerId: number): Promise<Locker> {
  return agent.requests.del(`/api/company/lockers/${lockerId}/assignment`, true);
}

export function getWaitingListRequest(rootOfficeId: number): Promise<WaitingList> {
  return agent.requests.get(`/api/company/lockers/office/${rootOfficeId}/waiting-list`);
}

export function joinWaitingListRequest(rootOfficeId: number, userId?: string): Promise<WaitingList> {
  return agent.requests.post(`/api/company/lockers/office/${rootOfficeId}/waiting-list`, { userId: userId ?? null });
}

export function leaveWaitingListRequest(entryId: number): Promise<WaitingList> {
  return agent.requests.del(`/api/company/lockers/waiting-list/${entryId}`, true);
}
